import React from "react";
import "./No.css";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import MobileScaleWrapper from "../MobileScaleWrapper";

const No = () => {
  const navigate = useNavigate();
  return (
    <MobileScaleWrapper gradientTop="#1a0a0a" gradientBottom="#2d1515">
      <div
        className="no-outer"
        style={{ backgroundColor: "black", height: "100vh", width: "100vw" }}
      >
        {/*swipe up from the bottom of the page when page is loaded*/}
        <motion.div
          initial={{ y: "100vh" }}
          animate={{ y: 0 }}
          exit={{ y: "100vh" }}
          transition={{ duration: 1 }}
        >
          <div className="no-container">
            {/* counteract the other annimation by swiping in from the "top"*/}
            <motion.div
              initial={{ y: "-100vh", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <h1>You Died!</h1>
              <div className="vertical-btn-container">
                <button
                  className="btn"
                  onClick={() => navigate("/archives/2025")}
                >
                  Respawn
                </button>
                <button
                  className="btn"
                  onClick={() => navigate("/archives/2025")}
                >
                  Cmon Bruh {":("}
                </button>
              </div>
              <p style={{ marginTop: "3rem" }}>look at what you did</p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </MobileScaleWrapper>
  );
};

export default No;
